import $ from 'jquery';

$(document).ready(() => {
  document.querySelectorAll('.customPaginatedNewsFilter, .customPaginatedProjectsFilter, .customPaginatedStoriesFilter, .customPaginatedInterviewsFilter').forEach((section) => {
    const options = section.querySelectorAll('.filterOption');
    function applyFilters(clear) {
      const target = new URL(section.dataset.filterUrl, window.location.href);
      options.forEach((option) => {
        const selected = Array.from(option.querySelectorAll('input:checked')).map((input) => input.dataset.value);
        if (!clear && selected.length) {
          target.searchParams.set(option.getAttribute('o-name'), selected.join(','));
        }
      });
      window.location.assign(target.href);
    }
    let hasFilters = false;
    options.forEach((option) => {
      const selected = option.querySelectorAll('input:checked');
      if (selected.length) {
        hasFilters = true;
        const optionText = option.querySelector('.optionText');
        optionText.textContent = Array.from(selected).map((input) => input.closest('label').querySelector('.optionTitle').textContent.trim()).join(', ');
      }
      option.addEventListener('change', () => {
        if (window.innerWidth > 760) applyFilters(false);
      });
    });
    if (window.innerWidth > 760) {
      const reset = section.querySelector('.removeFilter').cloneNode(true);
      reset.classList.remove('mobileFilterDisableBtn');
      reset.classList.add('tabFilterDisableBtn');
      const container = document.createElement('div');
      container.className = 'container';
      container.appendChild(reset);
      section.querySelector('.gi-news-filter').after(container);
    }
    section.querySelectorAll('.removeFilter').forEach((button) => {
      button.classList.toggle('filterInactive', !hasFilters);
      button.classList.toggle('filterActive', hasFilters);
      button.addEventListener('click', (event) => {
        event.preventDefault();
        applyFilters(true);
      });
    });
    section.querySelector('.applyFilter').addEventListener('click', (event) => {
      event.preventDefault();
      applyFilters(false);
    });
  });
});
